import gql from "graphql-tag";

export const USER_QUERY = gql`
  query User($id: UUID!) {
    user(id: $id) {
      customers {
        nodes {
          id
          cpf
          name
          phone
          email
          addresses {
            nodes {
              formattedAddress
            }
          }
        }
      }
    }
  }
`;
